/**
 * Language Selector Replacer
 */

define(function(require, exports, module) {
    'use strict';
    const core = require('core');
    const user = require('user');
    const _ = require('underscore');
    const language = require('util/language.util');
    const BaseReplacerView = require('common/base.replacer.view');

    module.exports = BaseReplacerView.extend({

        events: _.extend({}, BaseReplacerView.prototype.events, {
            'tap .fn-change-language': 'changeLanguage',
            'keydown .fn-change-language': 'onLanguageItemKeyDown'
        }),

        render: function() {
            this.$el.html(this.tmpl('language-selector', {
                allowedLocales: language.allowedLocales,
                selected: user.get('lang')
            }));

            return this;
        },

        changeLanguage: function(e) {
            this.$('.selected').removeClass('selected');
            e.currentTarget.classList.add('selected');

            core.trigger('user:action:changeLanguage', e.currentTarget.dataset.lang);
        },

        onLanguageItemKeyDown: function(event) {
            const { key } = event;

            if (key === 'Enter') {
                event.preventDefault();

                this.changeLanguage(event);
            }
        },

    }, {
        nameOfReplacers: [
            'LANGUAGE_SELECTOR'
        ]
    });
});
